$(document).ready(function() {
  $(window).scroll(function() {
    var currentScroll = $(window).scrollTop(),
        screenHeight = $(window).height(),
        pageHeight = $(document).height();
    if(currentScroll >= (pageHeight * 0.60) - (screenHeight * 0.50)) {
      if(!getCookie("firstvisit")) {
        $('#popupload').fadeIn(1000);
        $("#black-overlay4").fadeIn(500);
        $("#cookies-notice").fadeIn(1000)
        createCookie("firstvisit", "1", 1)
      }
    }
  });
})